// @ts-check
import React, { useCallback } from 'react';
import { useIntl } from 'react-intl';

import { Checkbox } from 'ui-components/components/checkbox';
import { FlexRow } from 'ui-components/components/flex';
import { Gap } from 'ui-components/components/flex/gap';
import { InfoIcon } from 'ui-components/components/info-icon';
import { Text, TextType } from 'ui-components/components/text';

import style from './style.module.css';
import { messages } from '../../../../../messages';
import { FORM_REQUIREMENTS } from '../../../../../utilities/constants';
import { useWalletRegistrationFormContext } from '../../../contexts/wallet-registration-form-context';

/**
 * @param {object} props
 * @param {boolean} props.isPickupSameAsBilling
 * @param {(checked: boolean) => void} props.setIsPickupSameAsBilling
 * @returns {React.ReactElement}
 */
export const PickupAddressCheckbox = ({ isPickupSameAsBilling, setIsPickupSameAsBilling }) => {
  const intl = useIntl();
  const { walletForm, updateWalletForm, submittingRegistration } = useWalletRegistrationFormContext();

  const onChange = useCallback(
    /** @param {boolean} checked */
    (checked) => {
      setIsPickupSameAsBilling(checked);
      if (checked) {
        updateWalletForm([FORM_REQUIREMENTS.PICKUP_ADDRESS], walletForm?.[FORM_REQUIREMENTS.BILLING_ADDRESS]);
      }
    },
    [setIsPickupSameAsBilling, walletForm, updateWalletForm],
  );

  return (
    <FlexRow className={style['pickup-address-checkbox']} gap={Gap.Space8}>
      <Checkbox
        checked={isPickupSameAsBilling}
        className={style.prompt}
        disabled={submittingRegistration}
        label={intl.formatMessage(messages.pickupAddressPrompt)}
        onChange={onChange}
      />
      <InfoIcon
        className={style['info-icon']}
        size='medium'
        tooltipText={<Text textType={TextType.Caption} value={messages.pickupAddressTooltip} />}
      />
    </FlexRow>
  );
};
